/**
 * Split an in-app href into pathname / search / hash so TanStack navigate
 * receives each piece separately. A `to` that still contains `?query` is
 * matched as a path and drops the params.
 */
export function parseHref(href: string): {
  pathname: string;
  search: Record<string, string>;
  hash: string | undefined;
} {
  const hashIdx = href.indexOf("#");
  const noHash = hashIdx >= 0 ? href.slice(0, hashIdx) : href;
  const hash = hashIdx >= 0 ? href.slice(hashIdx + 1) : undefined;
  const qIdx = noHash.indexOf("?");
  const pathname = (qIdx >= 0 ? noHash.slice(0, qIdx) : noHash) || "/";
  const searchStr = qIdx >= 0 ? noHash.slice(qIdx + 1) : "";
  return {
    pathname,
    search: Object.fromEntries(new URLSearchParams(searchStr)),
    hash: hash || undefined,
  };
}
